import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export function practiceStatusFormatter(status: any) {
  if (status === "passed") return i18n.tc(LocalesFields.CompletedAndPassed);
  if (status === "not_passed") return i18n.tc(LocalesFields.Failed);
  if (status === "waiting") return i18n.tc(LocalesFields.PendingReview);
  if (status === "send_to_revision")
    return i18n.tc(LocalesFields.SentForFinalization);
  if (status === undefined) return i18n.tc(LocalesFields.NotStarted);
}

export function templateTitle(name: string): string {
  let title: string = name;
  if (name === "act")
    title = i18n.tc(LocalesFields.CertificateOfCompletedWorks);
  if (name === "bill") title = i18n.tc(LocalesFields.Bill);
  if (name === "contract") title = i18n.tc(LocalesFields.Contract);
  if (name === "enrollment_order")
    title = i18n.tc(LocalesFields.OrderOfEnrollment);
  if (name === "expulsion_order")
    title = i18n.tc(LocalesFields.OrderOfCompletion);
  if (name === "education_protocol")
    title = i18n.tc(LocalesFields.TrainingProtocol);
  if (name === "final_document") title = i18n.tc(LocalesFields.FinalDocument);
  return title;
}
